import { useAppSelector } from "../../../store/hooks/StoreHooks";


interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    type?: string;
    label?: string;
    error?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string | number | undefined;
    name?: string;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    required?: boolean;
    unit?: string;
    bgColor?: string;
    icon?: { component: React.ReactNode; tooltipText?: string };
    link?: string;
    leftAlign?: boolean;
    className?: string;
    min?: number;
}

const TextShortInput: React.FC<TextInputProps> = ({
    type = "text",
    label,
    value,
    name,
    placeholder = "Enter text here",
    error,
    onChange,
    onBlur,
    disabled = false,
    readOnly = false,
    required = false,
    unit,
    bgColor = "bg-darkcolor-700",
    icon,
    link,
    leftAlign = false,
    className = "",
    min,
    ...props
}) => {

    const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

    return (
        <>
            {
                <div className={`flex ${!unit ? "justify-end" : "justify-between"}`}>
                    <input
                        className={`${className} ${((customerEnabled && !customerCreated) || projectReadOnly) && "text-neutral-400 cursor-not-allowed hover:border-neutral-600"}`}
                        name={name}
                        type={type}
                        step={"any"}
                        placeholder={placeholder}
                        onChange={onChange}
                        value={value}
                        onBlur={onBlur}
                        {...props}
                        disabled={disabled || (customerEnabled && !customerCreated) || projectReadOnly}
                        min={min}
                    />
                    {unit &&
                        <span className={`absolute right-3 top-1/2 transform -translate-y-1/2 text-neutral-25 ${((customerEnabled && !customerCreated) || projectReadOnly) && "text-neutral-400 hover:border-neutral-600"}`}>
                            {unit}
                        </span>
                    }

                </div>
            }
        </>
    )
}


export default TextShortInput;